import { makeSelector } from 'containers/app/selectors'

const spaceResults = (state) => state.getIn(['search', 'result', 'spaces'])
const userResults = (state) => state.getIn(['search', 'result', 'users'])
const searchQuery = (state) => state.getIn(['search', 'query'])

export const getSpaceResults = makeSelector(spaceResults)
export const getUserResults = makeSelector(userResults)
export const getSearchQuery = makeSelector(searchQuery)
